'use client';
import { NewInventoryFiltersContext } from '@/contexts/NewInventoryFiltersContext';
import { FilterSection } from '@/types/inventory';
import { Badge } from '@lamesarv-sdk/components';
import { getFacetCode } from '@lamesarv-sdk/tools';
import { useContext, useMemo } from 'react';
import { twMerge } from 'tailwind-merge';

interface PromotionsBadgesProps {
  tags: string[] | undefined;
  className?: string;
}

export const PromotionsBadges = ({ tags = [], className }: PromotionsBadgesProps) => {
  const { baseTagFilters } = useContext(NewInventoryFiltersContext);

  const availablePromotionsColorMap = useMemo(() => {
    const colors: string[] = ['bg-green-100 text-green-500', 'bg-red-100 text-red-500'];

    const availablePromotions = baseTagFilters.find((item) => item.name === FilterSection.PROMOTIONS)?.values || [];

    const map = new Map<string, string>();

    for (let i = 0; i < availablePromotions.length; i++) {
      map.set(availablePromotions[i], colors[i % colors.length]);
    }

    return map;
  }, [baseTagFilters]);

  const elements: JSX.Element[] = [];

  for (const tag of tags) {
    const prefix = `${FilterSection.PROMOTIONS}:`;

    if (!tag.startsWith(prefix)) continue;

    const promotion = tag.slice(prefix.length).trim();

    if (!promotion || !availablePromotionsColorMap.has(promotion)) continue;

    elements.push(
      <Badge
        key={`promotion-${getFacetCode(promotion)}`}
        dataTestId={`promotion-${getFacetCode(promotion)}`}
        className={twMerge(
          'text-center rounded py-[3px] px-2.5 text-xs font-medium',
          availablePromotionsColorMap.get(promotion),
          className,
        )}
      >
        {promotion}
      </Badge>,
    );
  }

  return elements;
};
